import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import SearchFilters from '../components/productionstatus/SearchFilters'
import Body from '../components/productionstatus/Body'
import HeaderLockup from '../components/mini/HeaderLockup'
import OrgAvatar from '../components/mini/OrgAvatar'
import { currentOrg } from '../selectors/organization'
import {
  fetchProductionStatusCounts,
  setAllQuestsFiltersAndNavigate,
  postViewInfoToLogging
} from '../actions/productionstatus'
import {
  getProuductionStatusStats,
  hasActiveFilters
} from '../selectors/productionstatus'

const FiltersContainer = styled.div`
  flex: 0;
  height: fit-content;
  position: relative;
`

const LevelsContainer = styled.div`
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
`

class ProductionStatus extends React.Component {
  constructor() {
    super()
    this.navigateToAllQuestsBound = this.navigateToAllQuests.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(fetchProductionStatusCounts())
    this.props.dispatch(postViewInfoToLogging())
  }

  render() {
    const { organization, productionStatusStats, totalCounts } = this.props
    return (
      <div className="production-status">
        <HeaderLockup
          organization={organization}
          section="Production Status"
          avatarComponent={<OrgAvatar organization={organization} />}
        />
        <div style={{ display: 'flex' }}>
          <FiltersContainer>
            <SearchFilters />
          </FiltersContainer>
          <LevelsContainer>
            {this.props.isFetchingCounts ||
            !totalCounts ||
            productionStatusStats.length === 0 ? (
              <div className="loading" />
            ) : (
              <Body
                productionStatusStats={productionStatusStats}
                totalCounts={totalCounts}
                dispatch={this.props.dispatch}
                hasActiveFilters={this.props.hasActiveFilters}
                clickHandler={this.navigateToAllQuestsBound}
                levelFilters={this.props.levelFilters}
              />
            )}
          </LevelsContainer>
        </div>
      </div>
    )
  }

  navigateToAllQuests(options) {
    this.props.dispatch(setAllQuestsFiltersAndNavigate(options))
  }
}

ProductionStatus.propTypes = {
  organization: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  productionStatusStats: PropTypes.array.isRequired,
  totalCounts: PropTypes.object,
  isFetchingCounts: PropTypes.bool.isRequired,
  hasActiveFilters: PropTypes.bool.isRequired,
  levelFilters: PropTypes.array.isRequired
}

export const mapStateToProps = state => ({
  organization: currentOrg(state),
  list: state.productionstatus.list,
  courses: state.mockcourses.items,
  productionStatusStats: getProuductionStatusStats(state),
  totalCounts: state.productionstatus.totalCounts,
  isFetchingCounts: state.productionstatus.isFetchingCounts,
  hasActiveFilters: hasActiveFilters(state),
  levelFilters: state.productionstatusfilters.mock_level_id_in || []
})

export default connect(mapStateToProps)(ProductionStatus)
export { ProductionStatus as ProductionStatusDisconnected }



// WEBPACK FOOTER //
// ./src/containers/ProductionStatus.js